<template>
  <div class="filter">
    <div v-show="type=='school'">
      <div class="filter1 flex">
        <div>
          <span>目标省份:</span>
          <el-select v-model="params.province_id" multiple placeholder="请选择" style="width: 200px;" @change="change(1)">
            <el-option v-for="item in data[0].list" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div>
          <span>院校类型:</span>
          <el-select v-model="params.school_category" placeholder="请选择" @change="change(5)">
            <el-option v-for="item in data[4].list" :key="item.value" :label="item.label" :value="item.value"
              @change="change">
            </el-option>
          </el-select>
        </div>
        <div v-if="xianding">
          <span>限定:</span>
          <el-select v-model="params.cwb" placeholder="请选择" @change="change(6)">
            <el-option v-for="item in typelist" :key="item.value" :label="item.label" :value="item.value"
              @change="change">
            </el-option>
          </el-select>
        </div>
        <div>
          <span>双一流:</span>
          <el-select placeholder="请选择" v-model="params.is_double" @change="change(4)" style="width: 120px;">
            <el-option v-for="item in doubleList" :key="item.value" :label="item.label" :value="item.value"
              @change="change">
            </el-option>
          </el-select>
        </div>
        <div>
          <span>办学类型:</span>
          <el-select v-model="params.school_type" placeholder="请选择" @change="change(2)">
            <el-option v-for="item in data[1].list" :key="item.value" :label="item.label" :value="item.value"
              @change="change">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="filter2 flex">
        <div>
          <span>985:</span>
          <el-select placeholder="请选择" v-model="params.is_985" @change="change(3)">
            <el-option v-for="item in data[3].list" :key="item.value" :label="item.label" :value="item.value"
              @change="change">
            </el-option>
          </el-select>
        </div>

        <div>
          <span>211:</span>
          <el-select placeholder="请选择" v-model="params.is_211" @change="change(4)">
            <el-option v-for="item in data[2].list" :key="item.value" :label="item.label" :value="item.value"
              @change="change">
            </el-option>
          </el-select>
        </div>

        <!-- <div class="flex">
            <span>搜索专业:</span>
            <el-input placeholder="请输入内容" v-model="params.schoolname" autocomplete="new-password" readonly
              onfocus="this.removeAttribute('readonly');">
              <el-button slot="append" icon="el-icon-search" @click="search()">搜索</el-button>
            </el-input>
          </div> -->
        <div class="flex">
          <span>搜索院校:</span>
          <el-input placeholder="请输入内容" v-model="params.school_name" autocomplete="new-password" readonly
            onfocus="this.removeAttribute('readonly');">
            <el-button slot="append" icon="el-icon-search" @click="search()">搜索</el-button>
          </el-input>
        </div>
        <button class="clear" @click="clear">清空</button>
      </div>
    </div>
    <div class="" v-show="type=='major'">
      <div class="flex major">
        <span style="color: gray">专业选择</span>
        <div>
          <span v-for="(item,index) in tabdata" :class="index==id?'active':''" class="major_one"
            @click="major_change(item,index)">
            {{item.name}}({{item.children.length}})
          </span>
        </div>
        <div class="more_major">
          <!--   <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
          </el-checkbox> -->
          <div style="margin: 15px"></div>
          <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="(item1,index) in majorList" :label="item1" :key="index">{{item1.name}}
            </el-checkbox>
          </el-checkbox-group>
          <!--  <div>
            <span>
              已选
            </span> <span v-for="(item,index) in checkedCities">{{item.name}}</span>
          </div> -->
          <el-button type="danger" @click="change">确定</el-button>
        </div>
      </div>

    </div>
    <div class="" v-show="type=='career'">
      <div class="flex major">
        <span style="color: gray">职业选择</span>
        <div>
          <span v-for="(item,index) in tabdata" :class="index==careerID?'active':''" class="major_one"
            @click="career_change(item,index)">
            {{item.name}}({{item.children.length}})
          </span>
        </div>
        <div class="more_major">
          <!--  <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
          </el-checkbox> -->
          <div style="margin: 15px"></div>
          <el-checkbox-group v-model="checkedCities1" @change="handleCheckedCitiesChange1">
            <el-checkbox v-for="(item1,index) in careerList" :label="item1" :key="index">{{item1.name}}
            </el-checkbox>
          </el-checkbox-group>
          <!--  <div>
            <span>
              已选
            </span> <span v-for="(item,index) in checkedCities">{{item.name}}</span>
          </div> -->
          <el-button type="danger" @click="change">确定</el-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        id: 0,
        doubleList: [{
          label: '双一流',
          value: '1'
        }, {
          label: '非双一流',
          value: '0'
        }],
        checkedCities: [],
        checkedCities1: [],
        majorList: [{
          id: 34,
          name: "哲学类",
          pid: 3
        }],
        careerList: [{
            "id": 3,
            "code": "02030502",
            "level": 2,
            "name": "兽药技术人员"
          },
          {
            "id": 4,
            "code": "02030200",
            "level": 2,
            "name": "植物保护技术人员"
          },
          {
            "id": 5,
            "code": "02030501",
            "level": 2,
            "name": "兽医"
          },
          {
            "id": 6,
            "code": "02030602",
            "level": 2,
            "name": "草业技术人员"
          },
          {
            "id": 7,
            "code": "02030300",
            "level": 2,
            "name": "园艺技术人员"
          },
          {
            "id": 8,
            "code": "02030400",
            "level": 2,
            "name": "作物遗传育种栽培技术人员"
          },
          {
            "id": 9,
            "code": "02030601",
            "level": 2,
            "name": "畜牧技术人员"
          },
          {
            "id": 10,
            "code": "02030100",
            "level": 2,
            "name": "土壤肥料技术人员"
          }
        ],
        data: [],
        showmore: false,
        schoolname: '',
        params: {
          province_id: [],
          school_type: "",
          is_985: '',
          is_211: '',
          batch_name: '',
          school_name: '',
          school_category: '',
          major_type_list: [],
          career_list: [],
          is_double: '',
          based_on: null,
          diff: null,
          rank_min: null,
          rank_max: null
        },
        typelist: [{
            value: 'danger',
            label: '冲刺'
          },
          {
            value: 'safe',
            label: '稳妥'
          }, {
            value: 'guarantee',
            label: '保底'
          }
        ]
      }
    },
    props: {
      xianding: {
        type: Array,
        required: false,
      },
      careerID: {
        type: Number,
        required: false
      },
      type: {
        type: String,
        required: false,
        default: 'major'
      },
      tabdata: {
        type: Array,
        required: false
      }
    },
    created() {
      this.$http.aiSchoolOptions().then(res => {
        this.data = res.data
      })
      if (this.$route.query.type1) {
        this.params.based_on = this.$route.query.type1
      }
    },
    methods: {

      handleCheckedCitiesChange(e) {
        this.params.major_type_list = this.checkedCities.map(item => {
          return item.id
        })
        console.log(this.params)
      },
      handleCheckedCitiesChange1(e) {
        this.params.career_list = this.checkedCities1.map(item => {
          return item.id
        })
        console.log(this.params)
      },
      major_change(item, index) {
        this.id = index
        this.majorList = item.children
      },
      career_change(item, index) {
        this.id = index
        this.careerList = item.children
      },
      change(num) {
        console.log(num)
        // this.params.num = num
        this.$emit('filter', this.params)
      },
      search() {
        this.$emit('searchSchool', this.params.school_name)
      },
      clear() {
        this.params.province_id = []
        this.params.banxue = []
        this.params.teshu = []
        this.params.is985 = ''
        this.params.is211 = ''
        this.params.name = ''
        this.params.school_name = ''
        this.params.category_id = ''
        this.$emit('clear')
      }
    }
  }
</script>

<style scoped lang="scss">
  .major {
    margin: 30px;

    span {
      margin-right: 30px;
    }
  }

  .major_one {
    position: relative;
    cursor: pointer;

    .more_major {
      position: absolute;
      width: 400px;
      padding: 0 20px;
      border: 1px solid #C10B17;
      border-radius: 4px;
      top: 20;
      top: 29px;
      left: 10px;
      z-index: 1111999;
      background: #ffffff;
    }
  }

  .active {
    color: #C10B17;
  }

  .filter1 {
    margin: 29px 20px;

    &>div {
      margin: 0 20px 0 0;
    }
  }

  .filter2 {
    &>div {
      margin: 0 20px 0 0;
    }

    margin: 29px 20px;

    .clear {
      width: 60px;
      height: 36px;
      border: 1px solid #C10B17;
      border-radius: 6px;
      color: #C10B17;
      background-color: #ffffff;
      color: #C10B17 !important;
    }

    .flex {
      flex-wrap: nowrap;

      span {
        width: 100px
      }
    }
  }

  .right {
    margin-left: 16px;
  }

  .filter {
    position: sticky;
    top: 0;
    background-color: #ffffff;
    // width: 979px;
    min-height: 149px;
    border: 1px solid #EDEDED;
    border-radius: 10px;
  }
</style>
<style>
  .el-radio__input.is-checked+.el-radio__label {
    color: #C10B17 !important;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: #C10B17 !important;
    border-color: #C10B17 !important;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #C10B17 !important;
    background-color: #C10B17 !important;
  }

  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #C10B17 !important;
  }

  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #C10B17 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/schoolfilter.vue